import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const TromboneIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <g id="Group 29613568">
        <path id="Vector" d="M5.99986 13.5005H1.49984V15.0006H5.99986V13.5005Z" fill={fillColor || '#F6F6F7'} />
        <path id="Vector_2" d="M7.50001 12.0005H5.99987V13.5006H7.50001V12.0005Z" fill={fillColor || '#F6F6F7'} />
        <path id="Vector_3" d="M9 10.5005H7.49988V12.0006H9V10.5005Z" fill={fillColor || '#F6F6F7'} />
        <path id="Vector_4" d="M1.50004 9.00049H-8.7738e-05V13.5005H1.50004V9.00049Z" fill={fillColor || '#F6F6F7'} />
        <path id="Vector_5" d="M10.5001 6.00049H8.99998V10.5005H10.5001V6.00049Z" fill={fillColor || '#F6F6F7'} />
        <path id="Vector_6" d="M2.99997 7.50049H1.49984V9.0006H2.99997V7.50049Z" fill={fillColor || '#F6F6F7'} />
        <path id="Vector_7" d="M4.50006 6.00049H2.99994V7.50061H4.50006V6.00049Z" fill={fillColor || '#F6F6F7'} />
        <path id="Vector_8" d="M8.99989 4.50049H4.49986V6.0006H8.99989V4.50049Z" fill={fillColor || '#F6F6F7'} />
        <path id="Vector_9" d="M22.4999 1.5006V0.000488281H19.5V3.00036H24V1.5006H22.4999Z" fill={fillColor || '#F6F6F7'} />
        <path
          id="Vector_10"
          d="M15 0.000488281V1.5006H13.4999V3.00036H11.9998V7.50033H13.4999V6.00058H15V9.00044H11.9998V12.0003H13.4999V10.5006H15V13.5004H11.9998V16.5003H13.4999V15.0005H15V18.0004H11.9998V19.5005H13.4999V21.0003H11.9998V19.5005H10.5V12.0003H8.99989V13.5004H7.49976V15.0005H5.99999V16.5003H4.49986V21.0003H5.99999V22.5004H7.49976V24.0005H13.4999V22.5004H15V21.0003H16.4998V3.00036H17.9999V0.000488281H15Z"
          fill={fillColor || '#F6F6F7'}
        />
      </g>
    </svg>
  );
};

export { TromboneIcon };
